/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CohortTypeEnum } from '../models/cohort-type-enum';
import { ProductTopIndustriesDto } from '../models/product-top-industries-dto';
import { VendorTopByProductsDto } from '../models/vendor-top-by-products-dto';
import { VendorTopCategoriesDto } from '../models/vendor-top-categories-dto';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTopVendorsByProducts
   */
  static readonly GetTopVendorsByProductsPath = '/statistics/vendor/top-by-products';

  /**
   * Get top vendors by number of products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopVendorsByProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopVendorsByProducts$Response(params?: {
    cohort?: CohortTypeEnum;
  }): Observable<StrictHttpResponse<Array<VendorTopByProductsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.GetTopVendorsByProductsPath, 'get');
    if (params) {
      rb.query('cohort', params.cohort, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VendorTopByProductsDto>>;
      })
    );
  }

  /**
   * Get top vendors by number of products.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTopVendorsByProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopVendorsByProducts(params?: {
    cohort?: CohortTypeEnum;
  }): Observable<Array<VendorTopByProductsDto>> {

    return this.getTopVendorsByProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VendorTopByProductsDto>>) => r.body as Array<VendorTopByProductsDto>)
    );
  }

  /**
   * Path part for operation getVendorTopCategories
   */
  static readonly GetVendorTopCategoriesPath = '/statistics/vendor/top-by-categories';

  /**
   * Get vendor count of top categories (by number of products).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVendorTopCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorTopCategories$Response(params?: {
    cohort?: CohortTypeEnum;
  }): Observable<StrictHttpResponse<Array<VendorTopCategoriesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.GetVendorTopCategoriesPath, 'get');
    if (params) {
      rb.query('cohort', params.cohort, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VendorTopCategoriesDto>>;
      })
    );
  }

  /**
   * Get vendor count of top categories (by number of products).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVendorTopCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorTopCategories(params?: {
    cohort?: CohortTypeEnum;
  }): Observable<Array<VendorTopCategoriesDto>> {

    return this.getVendorTopCategories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<VendorTopCategoriesDto>>) => r.body as Array<VendorTopCategoriesDto>)
    );
  }

  /**
   * Path part for operation getTopIndustriesByProduct
   */
  static readonly GetTopIndustriesByProductPath = '/statistics/product/{id}/top-industries';

  /**
   * Get top industries by product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopIndustriesByProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopIndustriesByProduct$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Array<ProductTopIndustriesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.GetTopIndustriesByProductPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductTopIndustriesDto>>;
      })
    );
  }

  /**
   * Get top industries by product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTopIndustriesByProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopIndustriesByProduct(params: {
    id: string;
  }): Observable<Array<ProductTopIndustriesDto>> {

    return this.getTopIndustriesByProduct$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductTopIndustriesDto>>) => r.body as Array<ProductTopIndustriesDto>)
    );
  }

}
